module.exports = __webpack_public_path__ + "img/j1.918c7320.png";